/**
 * Background debate setup: the backend picks the expert panel (with a reason
 * for each expert) and classifies the question while the user is still in the
 * setup flow.
 */
import { AnswerFormat, OPEN_ENDED, parseAnswerFormat } from "../utils/verdict";

const PREPARE_URL = "https://us-central1-familyaichat-1998.cloudfunctions.net/prepareDebate";

export interface ExpertPick {
  key: string;
  reason: string;
}

export interface DebatePrep {
  /** The trimmed question this was prepared for. */
  question: string;
  experts: ExpertPick[];
  category: string | null;
  format: AnswerFormat;
}

export async function requestDebatePrep(question: string, signal?: AbortSignal): Promise<DebatePrep> {
  const trimmed = question.trim();
  const resp = await fetch(PREPARE_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ question: trimmed }),
    signal,
  });
  if (!resp.ok) throw new Error(`prepareDebate responded ${resp.status}`);
  const data = await resp.json();
  const experts: ExpertPick[] = Array.isArray(data?.experts)
    ? data.experts
        .filter((e: any) => e && typeof e.key === "string")
        .map((e: any) => ({ key: e.key, reason: typeof e.reason === "string" ? e.reason : "" }))
    : [];
  return {
    question: trimmed,
    experts,
    category: typeof data?.category === "string" ? data.category : null,
    format: parseAnswerFormat(data?.format) ?? OPEN_ENDED,
  };
}
